import store from "../../../store";
import router from "../../../router";
import {make} from 'vuex-pathify'
import {DialogProgrammatic as Dialog} from 'buefy';
import { i18n } from "../../../i18n";

const state = {
    resource_form: {},
    prospect: {},
    form: {},
    errors: {},
}

// getters
const getters = {
    isPathExist: (state, getters) => (path) => {
        return _.includes(state.form.getAllStepsKeys(), path);
    },
    isPathNotExist: (state, getters) => (path) => {
        return !getters.isPathExist(path);
    },
    getFormData: (state) => (data_list) => {
        let form_data = {}
        _.forEach(data_list, (field) => {
            form_data[field] = store.get('form_data/' + field);
        })

        return form_data
    }
}

function cleanGuardDatas(state) {
    // Detect if steps has a guard
    let guard_steps = _.keys(_.pickBy(state.form._steps, (step)=>{
        return step._guard == true;
    }))
    // let guard_step = _.findKey(state.form._steps, ['_guard', true]);

    // If Guard exist, clean storage with guard keys
    if(!_.isEmpty(guard_steps)){
        _.forEach(guard_steps, (guard_step)=>{
            let guard_reset_datas = state.form._steps[guard_step]._guard_reset_datas
            if(_.size(guard_reset_datas)>0){
                let defaultStateFormData = store.get('form_data/defaultState')
                _.forEach(guard_reset_datas, (data_to_reset)=>{
                    // Module path
                    if(_.includes(data_to_reset,'/')){
                        let [moduleName,path] = data_to_reset.split("/");
                        let jsonPath = path.replace('@','.')
                        let defaultValue = _.get(store.get(moduleName+'/defaultState'),jsonPath)
                        store.set(moduleName+'/'+path, defaultValue);
                        // Default to form_data
                    }else{
                        let jsonPath = data_to_reset.replace('@','.')
                        let defaultValue = _.get(defaultStateFormData,jsonPath)
                        store.set('form_data/'+data_to_reset, defaultValue);
                    }
                })
            }
        })
    }
}

// actions
const actions = {
    createObjToSend({getters}, {step, button}) {
        let objToSend = {}

        // Form Data
        let form_data = getters.getFormData(step._fields_to_send)

        let extra_data = step._extra_data_to_send;

        // General Data
        let general_data = _.cloneDeep(store.get('general_data'));

        objToSend = {
            ...form_data,
            ...general_data,
            ...extra_data,
        }

        if (button) {
            let button_form_data = getters.getFormData(button._fields_to_send)
            let button_extra_data = button._extra_data_to_send;
            objToSend = {
                ...objToSend,
                ...button_form_data,
                ...button_extra_data,
            }
        }

        return objToSend;
    },

    async goBack({dispatch, state}){
        if(store.get('func_data/block_form')){
            return ;
        }

        store.set('func_data/back_enter_status',false)

        let steps_track = _.cloneDeep(store.get('general_data/steps_track'));
        let back_step_index = _.size(steps_track)-2;
        if(back_step_index>=0){
            let back_step = steps_track[back_step_index];

            let currentStep = store.get('form/form@_steps.' + router.currentRoute.params.step)
            if(currentStep._back_animate_duration || currentStep._enter_animate_duration){
                store.set('func_data/go_to_status', true)
                store.set('func_data/back_animate_status',true)
                await dispatch('sleep', currentStep._back_animate_duration || currentStep._enter_animate_duration)
                store.set('func_data/back_animate_status',false)
            }

            store.set('func_data/back_enter_status',true)

            return dispatch('goTo', back_step).then(() => {
                store.set('general_data/current_step', back_step)
                steps_track.pop()
                store.set('general_data/steps_track', steps_track)

                store.set('form/printStepsLog', {step:back_step,type:'back'})
            })
        } else {
            let firstStep = _.isFunction(state.form._first_step) ? state.form._first_step() : state.form._first_step;
            return dispatch('goTo', firstStep).then(() => {
                store.set('general_data/current_step', firstStep)
            })
        }
    },

    async goToNextStep({dispatch, getters, commit}, button = null) {
        // Status
        if(store.get('func_data/disable_form')){
            return ;
        }

        if(store.get('func_data/block_form')){
            return ;
        }

        store.set('func_data/go_to_status', false)

        let validation_observer = store.get('func_data/validation_observer')

        // RESET ERRORS
        await _.result(validation_observer,'reset')
        store.set('form/errors', {})

        let func_data = store.get('func_data')
        let currentStep = store.get('form/form@_steps.' + router.currentRoute.params.step)

        // Front Validation
        if (!await _.result(validation_observer, 'validate', true)) {
            store.set('func_data/go_to_status', true)
            return;
        }
        let objToSend = await dispatch('createObjToSend', {step: currentStep, button})

        // Check if should send request
        let canISendRequest = button ? currentStep.shouldSendRequest() || button.shouldSendRequest() : currentStep.shouldSendRequest()
        if (canISendRequest) {
            try {
                // Send Request
                // check if step has api endpoint, if not pick the form api endpoint
                let api_endpoint = currentStep._api_endpoint || store.get('form/form@_api_endpoint');
                let response = await axios.post(api_endpoint, objToSend)
                store.set('general_data/match_token', response.data.match_token)
            } catch ({response}) {
                // Validation error
                if (_.get(response, 'status', 500) == 422) {
                    let back_errors = _.get(response, 'data.errors', {});
                    _.invoke(validation_observer,'setErrors',back_errors)

                    // Errors outside form input
                    let fieldsInFormKeys = _.keys(_.get(validation_observer,'fields',{}));
                    let errorsOutsideForm = {}
                    _.forEach(back_errors, async (back_error_value, back_error_key) => {
                        if(back_error_value == 'user_already_registered'){
                            await dispatch('fatalErrorModal')
                            return await dispatch('reset');
                        }
                        if (!_.includes(fieldsInFormKeys, back_error_key)) {
                            errorsOutsideForm[back_error_key] = back_error_value
                        }
                    })
                    store.set('form/errors', errorsOutsideForm);
                    store.set('func_data/go_to_status', true)
                    return;
                    // Other Errors, Cut the app
                } else {
                    store.set('func_data/go_to_status', true)
                    await dispatch('fatalErrorModal')
                    return await dispatch('reset');
                }
            }
        }
        // apply before leave
        await dispatch('applyBeforeLeave', currentStep)
        store.set('general_data/updated_at_front', window.DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'))

        let button_next_step = null;
        if(button){
            button_next_step = _.get(button, '_next_step') || currentStep._next_step;
        }
        let nextStep = button_next_step || currentStep._next_step;
        nextStep = _.isFunction(nextStep) ? await Promise.resolve(nextStep()) : nextStep

        if(currentStep._leave_animate_duration){
            store.set('func_data/go_to_status', true)
            store.set('func_data/leave_animate_status',true)
            await dispatch('sleep',currentStep._leave_animate_duration)
            store.set('func_data/leave_animate_status',false)
        }

        store.set('func_data/back_enter_status',false)

        return dispatch('goTo', nextStep).then(() => {
            if(!_.startsWith(nextStep, 'http')){
                store.set('func_data/go_to_status', true)
                store.set('general_data/current_step', nextStep)
                let steps_track = _.cloneDeep(store.get('general_data/steps_track'));
                store.set('general_data/steps_track', [...steps_track, nextStep])

                store.set('form/printStepsLog', {step: nextStep,type:'next'})
            }
        })
    },



    async applyBeforeLeave({}, step) {
        if (_.isNull(step._before_leave)) {

        } else {
            await Promise.resolve(step._before_leave())
        }
    },

    reloadToFirstStep({state},payload) {
        let redirect_link = _.get(payload,['redirect_link'])

        if(redirect_link){
            return location.href = '/' + redirect_link + _.get(payload,'query_string','');
        }
        let firstStep = _.isFunction(state.form._first_step) ? state.form._first_step() : state.form._first_step;
        return location.href = '/' + window.slug + '/' + firstStep + _.get(payload,'query_string','');
    },
    clear() {
        store.commit('form_data/resetState');
        store.commit('general_data/resetState');
        return;
    },
    reset({dispatch, state}) {
        let query_string = location.search
        let redirect_link = _.get(state.resource_form,['part_1_form','slug'])
        dispatch('clear');
        return dispatch('reloadToFirstStep', {
            query_string:location.search,
            redirect_link : redirect_link
        });
    },
    goTo({dispatch}, step) {

        if(_.startsWith(step, 'http')){
            location.href = step;
            return;
        } else {
            let query = window.queryString.parse(location.search)
            return router.push({
                name: 'form',
                params: {step},
                query
            });
        }
    },

    async resetModal() {
        return await new Promise((resolve, reject) => {
            Dialog.confirm({
                message: i18n.t('app.modals.session.title'),
                confirmText: i18n.t('app.modals.session.confirm'),
                cancelText: i18n.t('app.modals.session.cancel'),
                canCancel: ['button', 'escape'],
                type: 'is-black',
                onConfirm: () => resolve(true),
                onCancel: () => resolve(false),
            })
        })
    },

    async fatalErrorModal() {
        return await new Promise((resolve, reject) => {
            Dialog.alert({
                message: i18n.t('app.modals.error.title'),
                confirmText: i18n.t('app.modals.error.confirm'),
                type: 'is-black',
                onConfirm: () => resolve(true),
            })
        })
    },
    async sleep({dispatch},timer){
        return await new Promise((resolve, reject) => {
            window.setTimeout(()=>{
                resolve()
            },timer*1000)
        })
    },
    async guardRoute({dispatch, getters, state}) {
        let route = router.currentRoute;
        let userLastStep = store.get('general_data/current_step');
        let query_string = location.search;
        let firstStep = _.isFunction(state.form._first_step) ? state.form._first_step() : state.form._first_step;

        // Different version
        if (store.get('form/resource_form@version') != store.get('general_data/version')) {
            return await dispatch('reset');
        }

        // Different device
        if (window.device != store.get('general_data/device')) {
            return await dispatch('reset');
        }

        // Different form_token
        if (store.get('form/resource_form@token') != store.get('general_data/form_token')) {
            return await dispatch('reset');
        }

        if(!_.isEmpty(store.get('general_data/created_at_front'))){
            if(window.DateTime.dayPassed(30,store.get('general_data/created_at_front'))){
                return await dispatch('reset');
            }
        }

        // Clean guard datas
        cleanGuardDatas(state)

        // If not step param, redirect to first step
        if (!route.params.step) {
            return dispatch('reloadToFirstStep', {query_string:location.search});
        }

        // if user last step not exist in form steps, clear localstorage and redirect to first step
        if (userLastStep) {
            if (getters.isPathNotExist(userLastStep)) {
                return dispatch('reset');
            }
        }

        // if route path not exist, redirect to first step
        if (getters.isPathNotExist(route.params.step)) {
            return dispatch('reloadToFirstStep', {query_string:location.search});
        }

        // reset Modal

        if (store.get('general_data/is_dirty')) {
            store.set('func_data/disable_form',true)
            let keepSession = await dispatch('resetModal')
            store.set('func_data/disable_form',false)
            if (!keepSession) {
                return dispatch('reset');
            }
        }

        // go to user last step if exist
        if (userLastStep) {

            // check if steps_track has guard step in array and redirect to guard step
            let guard_step = _.findKey(state.form._steps, ['_guard', true]);
            let steps_track = store.get('general_data@steps_track')
            if(_.includes(steps_track,guard_step)){
                userLastStep = guard_step;
                let guardStepIndexInStepsTrack = _.indexOf(steps_track, guard_step);
                store.set('general_data/steps_track',steps_track.slice(0,guardStepIndexInStepsTrack+1))
                store.set('general_data/current_step',guard_step)
            }
            if (route.params.step != userLastStep) {
                store.set('form/printStepsLog', {step:userLastStep,type:'guard'})
                return dispatch('goTo', userLastStep)
            }
        }

        // if it's his first time and try to go to another step, then redirect to first step
        if (!userLastStep) {
            if (route.params.step != firstStep) {
                return dispatch('reloadToFirstStep', {query_string:location.search})
            }
        }


        store.set('form/printStepsLog',{step:route.params.step || null,type:'load'})
        if (_.isEmpty(store.get('general_data/steps_track'))) {
            store.set('general_data/steps_track', [route.params.step ? route.params.step : firstStep])
        }
        store.set('general_data/current_step',_.get(route,'params.step'));
    }
}

// mutations
const mutations = {
    ...make.mutations(state),
    printStepsLog(state, payload){
        let obj = {
            timestamps:Date.now(),
            ...payload
        }
        let steps_log = _.cloneDeep(store.get('general_data/steps_log'))
        steps_log.push(obj);
        store.set('general_data/steps_log',steps_log)
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
